<ng-container>
  @if ((isSearchFormReady$ | async)===false) {
    <div class="spinner-container">
      <mat-spinner aria-label="Loading"></mat-spinner>
    </div>
  } @else {
    <div class="appform-header">
      <button #buttons id="createApplicationButton" routerLink="/application_form" (click)="newOnClick()">
        <span>New</span>
      </button>
    </div>
    <div class="appform-container">
      <h2 class="section-header">Search</h2>
      <app-search-header></app-search-header>
      <div class="container-section">
        @if ((areSearchLoading$ | async)===false;) {
          <div class="spinner-container">
            <mat-spinner aria-label="Loading"></mat-spinner>
          </div>
        }
        @if (isTableLoaded) {
          <div>
            <app-search-detail [dataSource]="dataSource" [displayedColumns]="displayedColumns" [activeSortColumn]="matSortActive" [activeSortDirection]="matSortDirection" (viewButtonClick)="viewApplication($event)" (sortChange)="onSearchChanged($event)"></app-search-detail>
          </div>
        }
        <div class="mat-elevation-z8" [class.hidden]="(areSearchLoading$ | async)===false">
          <mat-paginator (page)="onPageSelect($event)" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons aria-label="Select page of periodic elements">
          </mat-paginator>
        </div>
      </div>
    </div>
  }
</ng-container>